import { FrontendApplicationContribution } from '@theia/core/lib/browser';
import { inject, injectable } from '@theia/core/shared/inversify';
import { WorkspaceService, type WorkspaceInput } from '@theia/workspace/lib/browser/workspace-service';
import { BrowserGitHubWorkspaceService } from './github-workspace-service';

type ReloadWindow = (workspacePath: string, options?: WorkspaceInput) => void;

type WorkspaceServiceReloadAccess = {
    reloadWindow: ReloadWindow;
};

@injectable()
// Theia closes workspaces by clearing the URL hash and reloading the window, but Online Preview
// also uses the `repo` query parameter for auto-loading. Clear that query before the reload so
// "Close Workspace" returns to the launcher instead of reopening the same GitHub project.
export class OnlinePreviewWorkspaceCloseContribution implements FrontendApplicationContribution {
    @inject(WorkspaceService)
    protected readonly workspaceService!: WorkspaceService;

    @inject(BrowserGitHubWorkspaceService)
    protected readonly githubWorkspaceService!: BrowserGitHubWorkspaceService;

    protected isRegistered: boolean = false;

    onStart(): void {
        if (this.isRegistered) return;

        const workspaceService: WorkspaceServiceReloadAccess = this
            .workspaceService as unknown as WorkspaceServiceReloadAccess;
        const reloadWindow: ReloadWindow = workspaceService.reloadWindow.bind(this.workspaceService);

        workspaceService.reloadWindow = (workspacePath: string, options?: WorkspaceInput): void => {
            if (workspacePath === '' && this.githubWorkspaceService.shouldClearLocationForWorkspaceClose()) {
                this.githubWorkspaceService.clearOnlinePreviewLocation();
            }

            reloadWindow(workspacePath, options);
        };

        this.isRegistered = true;
    }
}
